import { object, string } from 'yup'
import { i18nErrorCodes } from '../form-utils'

const { required } = i18nErrorCodes

export default object().shape({
  name:   string().required(required),
  school: string().required(required),
})

export const emptyStudy = {
  name:   '',
  school: '',
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/study.schema.ts